import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from 'uitk-react-button';
import { inject } from 'mobx-react';
import { UitkText } from 'uitk-react-text';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { getApplicableRules } from '../../../global-navigation/header/gc-section-data';
export var FooterButtonSection = inject('page')(function (_a) {
    var _b;
    var page = _a.page, section = _a.section;
    var buttonTypes = new Map([
        ['Primary', UitkPrimaryButton],
        ['Secondary', UitkSecondaryButton],
        ['Tertiary', UitkTertiaryButton]
    ]);
    var getButton = function (item) {
        var _a, _b, _c;
        var rules = getApplicableRules(item);
        var fontSize = 300;
        var Button = ClickTracker(buttonTypes.has(rules.type) ? buttonTypes.get(rules.type) : UitkPrimaryButton);
        var pageName = (page === null || page === void 0 ? void 0 : page.pageName) || 'HomePage';
        var url = ((_a = item.url) === null || _a === void 0 ? void 0 : _a.includes('{PAGE_NAME}'))
            ? (_b = item.url) === null || _b === void 0 ? void 0 : _b.replace('{PAGE_NAME}', pageName)
            : (_c = item.url) === null || _c === void 0 ? void 0 : _c.replace('utm_campaign=pwa-header', "utm_campaign=".concat(pageName));
        return (React.createElement(Button, { id: item.id, rfrr: item.trackingEvent, href: url, linkName: item.id, trackImmediate: true },
            React.createElement(UitkIcon, { name: item.iconName, size: UitkIconSize.MEDIUM }),
            item.text && React.createElement(UitkText, { size: fontSize }, item.text)));
    };
    var getComponent = function (item) {
        switch (item.type) {
            case 'link': return getButton(item);
            case 'separator': return React.createElement("hr", null);
            default: return null;
        }
    };
    if (!((_b = section === null || section === void 0 ? void 0 : section.sectionData) === null || _b === void 0 ? void 0 : _b.length)) {
        return null;
    }
    return (React.createElement("ul", { className: "no-bullet" }, section.sectionData
        .filter(function (item) { return item && ['link', 'separator'].indexOf(item.type) !== -1; })
        .map(function (item) { return (React.createElement("li", { key: item.id }, getComponent(item))); })));
});
//# sourceMappingURL=footer-button-section.js.map